export const saveMessage = "SAVE_MESSAGE";
export const saveMessageTemplate = "SAVE_MESSAGE_TEMPLATE";
export const clearMessage = "CLEAR_MESSAGE";

export const getMessageBegin = "GET_MESSAGE_BEGIN";
export const getMessageSuccess = "GET_MESSAGE_SUCCESS";
export const getMessageFailure = "GET_MESSAGE_FAILURE";

export const setMessage = "SET_MESSAGE";
